export function StepProgress({ totalSteps, currentStep, onRestart }: { totalSteps: number, currentStep: number, onRestart: () => void }) {
    return (
        <div className="flex items-center gap-[19px]">
            <button className="text-text-primary text-sm font-normal opacity-60 hover:opacity-100" onClick={onRestart}>Restart</button>
            {Array.from({ length: totalSteps }).map((_, index) => (
                <div key={index} className={`w-[70px] h-2 rounded-full ${(index + 1) <= currentStep ? 'bg-primary' : 'bg-gray-300'}`}></div>
            ))}
        </div>
    );
}